var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "post card mb-3" }, [
    _c("div", { staticClass: "card-body p-4 p-lg-5" }, [
      _c("div", { staticClass: "d-flex mb-2" }, [
        _c("div", [
          _c("small", {}, [_vm._v(_vm._s(_vm.studentsName))]),
          _vm._v("\n        >\n        "),
          _c("small", {}, [
            _c(
              "a",
              { staticClass: "text-dark", attrs: { href: _vm.topicLink } },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.post.community_topic.title) +
                    "\n          "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("small", { staticClass: "text-muted" }, [
            _vm._v(_vm._s(_vm.time(_vm.post.created_at))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("a", { staticClass: "text-dark", attrs: { href: _vm.postLink } }, [
          _c(
            "h4",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.post.title,
                  expression: "post.title",
                },
              ],
              staticClass: "fw-bold",
            },
            [_vm._v(_vm._s(_vm.post.title))]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.post.student_id
        ? _c("div", { staticStyle: { "white-space": "pre-wrap" } }, [
            _vm._v(_vm._s(_vm.post.body)),
          ])
        : _c("div", {
            staticStyle: { "white-space": "pre-wrap" },
            domProps: { innerHTML: _vm._s(_vm.markdown(_vm.post.body)) },
          }),
      _vm._v(" "),
      _vm.post.image
        ? _c("div", { staticClass: "mt-3" }, [
            _c("img", { staticClass: "img-fluid", attrs: { src: _vm.imgUrl } }),
          ])
        : _vm.post.bunny_id && !_vm.post.bunny_status
        ? _c("div", { staticClass: "mt-3" }, [
            _c(
              "div",
              { staticClass: "ratio ratio-16x9 bg-secondary-subtle" },
              [_c("Spinner")],
              1
            ),
          ])
        : _vm.post.bunny_id && _vm.post.bunny_status === 3
        ? _c("div", { staticClass: "mt-3" }, [
            _c("div", { staticClass: "ratio ratio-16x9" }, [
              _c("iframe", {
                attrs: {
                  src: `https://player.mediadelivery.net/embed/25534/${_vm.post.bunny_id}?autoplay=false&preload=false`,
                  loading: "lazy",
                  allow:
                    "accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;",
                  allowfullscreen: "true",
                },
              }),
            ]),
          ])
        : _vm.post.video
        ? _c("div", { staticClass: "mt-3" }, [
            _c("div", { staticClass: "ratio ratio-16x9" }, [
              _c("iframe", {
                staticClass: "embed-responsive-item",
                attrs: { src: _vm.post.video },
              }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-2 d-flex" },
        [
          _c("Votes", { attrs: { votable: _vm.post } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ms-2" },
            [
              _vm.hasRouter
                ? _c(
                    "router-link",
                    {
                      staticClass: "text-dark",
                      attrs: {
                        to: {
                          name: "community.posts.show",
                          params: {
                            post: _vm.post.id,
                          },
                        },
                      },
                    },
                    [
                      _c("small", [
                        _c("i", { staticClass: "far fa-comment" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.post.comments_count) +
                            "\n          "
                        ),
                      ]),
                    ]
                  )
                : _c(
                    "a",
                    { staticClass: "text-dark", attrs: { href: _vm.postLink } },
                    [
                      _c("small", [
                        _c("i", { staticClass: "far fa-comment" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.post.comments_count) +
                            "\n          "
                        ),
                      ]),
                    ]
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }